import React from 'react';
import { renderPromotionOption } from '@css-xp/base';
import DeleteIcon from '@atlaskit/icon/glyph/editor/remove';
import Button from '@atlaskit/button';
import { SkeletonLoader, SkeletonLoaderWrapper } from '@css-xp/skeleton-loader';
import { PromotionTypes } from '../../../types';
import { AppPromotionResponse } from '../../types/store-types';

interface Props {
  promotions: AppPromotionResponse[];
  removeAppliedPromocode?: (_promotionId: string) => void;
  isRemovePromotionsEnabled?: boolean;
  isLoading?: boolean;
  isDiscretionaryDiscountsExcluded?: boolean;
  shouldShowLegacyInvoiceId?: boolean;
}

export const AppliedPromotions = ({
  promotions,
  removeAppliedPromocode,
  isRemovePromotionsEnabled,
  isLoading = false,
  isDiscretionaryDiscountsExcluded = false,
  shouldShowLegacyInvoiceId = false,
}: Props) => {
  const appliedPromotions = isDiscretionaryDiscountsExcluded
    ? promotions?.filter((promotion) => promotion.type !== PromotionTypes.DISCRETIONARY_DISCOUNT)
    : promotions;

  return (
    <div className="applied-promotions">
      <h5>Applied discounts and promotions</h5>
      <div className="applied-promotions-content">
        {isLoading ? (
          <SkeletonLoaderWrapper>
            <SkeletonLoader />
          </SkeletonLoaderWrapper>
        ) : (
          <>
            {' '}
            {appliedPromotions && appliedPromotions?.length > 0 ? (
              <>
                {appliedPromotions?.map((promotion, index) => {
                  /*
            promotion?.promocode is added by newly added promocode flow
            promotion?.promotionCode is coming from existing applied promotion
          */
                  const promocode = promotion?.promocode ?? promotion?.promotionCode;
                  return (
                    <div className="promotion-details" key={index}>
                      <div className="promo-code-promotion-details">
                        {promocode && <span className="mv8">{`Promocode: ${promocode}`}</span>}
                        {renderPromotionOption(promotion, {
                          showBenefitNextLine: true,
                          showLegacyInvoiceId: shouldShowLegacyInvoiceId,
                        })}
                      </div>
                      {isRemovePromotionsEnabled && (
                        <Button
                          onClick={() => {
                            if (promotion?.id) {
                              removeAppliedPromocode?.(promotion.id);
                            }
                          }}
                          iconBefore={<DeleteIcon label="remove" />}
                          appearance="subtle"
                          className="product-rows-container--delete-btn"
                          testId={`remove-applied-promotion-${promotion?.id}`}
                        />
                      )}
                    </div>
                  );
                })}
              </>
            ) : (
              <span>No discount or promotion applied to this line item</span>
            )}
          </>
        )}
      </div>
    </div>
  );
};
